module.exports = __webpack_public_path__ + "img/4.3a92a7cd.jpg";